import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页', icon: 'ri-home-4-line' },
    { to: '/category/movie', label: '电影', icon: 'ri-film-line' },
    { to: '/category/tv', label: '电视剧', icon: 'ri-tv-line' },
    { to: '/category/variety', label: '综艺', icon: 'ri-mic-line' },
    { to: '/category/anime', label: '动漫', icon: 'ri-emotion-line' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-100/95 backdrop-blur-md shadow-lg shadow-black/20'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 shrink-0 cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-heading text-gradient-primary whitespace-nowrap">
                春色影视
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    location.pathname === link.to
                      ? 'bg-primary-500/20 text-primary-500'
                      : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50'
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={link.icon}></i>
                  </span>
                  {link.label}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <Link
                to="/about"
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === '/about'
                    ? 'text-primary-500'
                    : 'text-foreground-400 hover:text-foreground-200'
                }`}
              >
                关于我们
              </Link>
              <button className="flex items-center gap-1.5 px-4 py-2 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line"></i>
                </span>
                搜索
              </button>
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50 transition-all duration-200 cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="bg-background-100/98 backdrop-blur-md border-t border-background-200/50 px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                  location.pathname === link.to
                    ? 'bg-primary-500/20 text-primary-500'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={link.icon}></i>
                </span>
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500/20 text-primary-500'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-information-line"></i>
              </span>
              关于我们
            </Link>
          </div>
        </div>
      </nav>

      <div className="h-16"></div>
    </>
  );
}